import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import ConfigsContext from '../../contextProviders/ConfigsContext';

const ACADEMY_TABS = {
  COURSES: 'courses',
  SESSIONS: 'sessions',
  JOURNEYS: 'journeys',
};
function WhiteBar({ t, filter }) {
  const isActive = tab => (tab === filter ? 'academy-tab-active' : '');
  const { organization } = useContext(ConfigsContext);
  const { enabled } = organization?.services?.journey || {};
  const { enabled: sessionsEnabled } = organization?.services?.sessions || {};
  return (
    <div className="white-bar_container">
      <div className="filter-box col-lg-12">
        <a href="/academy" className={isActive(ACADEMY_TABS.COURSES)}>
          <span className="white-bar_container-tabs">
            {t('academy.whiteBar.courses')}
          </span>
        </a>
        {sessionsEnabled && (
          <a
            href="/academy/sessions"
            className={isActive(ACADEMY_TABS.SESSIONS)}
          >
            <span className="white-bar_container-tabs">
              {t('academy.whiteBar.sessions')}
            </span>
          </a>
        )}
        {enabled && (
          <a
            href="/academy/journeys"
            className={isActive(ACADEMY_TABS.JOURNEYS)}
          >
            <span className="white-bar_container-tabs">
              {t('academy.whiteBar.journeys')}
            </span>
          </a>
        )}
      </div>
    </div>
  );
}

WhiteBar.propTypes = {
  t: PropTypes.func.isRequired,
  filter: PropTypes.string,
};

WhiteBar.defaultProps = {
  filter: null,
};

export default translate(WhiteBar);
